<script>
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
	import PageSection from "../../components/PageSection.svelte";
	import IFrame from "../../components/IFrame.svelte";
	import Checkbox from "../../components/Checkbox.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	import { pageNumber, model } from "../../stores";
	import { projectSettings } from "../../config";

	export let pageIndex = null;
	export let pageTitle = null;
	export let nextPage = null;
	export let previousPage = null;
	export let persistUrl = null;
	export let lastVisitedPage = null;

	$model.LastPageVisited = lastVisitedPage;
	document.title = pageTitle;

	//  Check for the back button
	if ($model.submitted) {
		alert("The form has already been submitted.");
		window.location.href = "/";
	} else {
		pageNumber.update((p) => pageIndex);
	}

	let url = `/documents/Ruby Princess Class Action_Conflicts Disclosure Statement.pdf`;
</script>

<PageSection>
	<h2>Conflicts Disclosure Statement</h2>

	<div class="form-row form-group">
		<div class="col-md-12">
			The Corporations Act 2001 (Cth) requires that, in respect of the class action Proceedings, the Litigation
			Funder (<b>Balance</b>) must maintain adequate practices for management of conflicts of interest.
		</div>
	</div>
	<div class="form-row form-group">
		<div class="col-md-12">
			This letter is written to you to provide you with information to assist you in understanding Balance's
			interests, any potential conflicts with group member's interests and how any conflicts will be managed.
		</div>
	</div>
	<div class="form-row form-group">
		<div class="col-md-12">
			This letter is an important document and we ask you to read it carefully. You are not required to sign the
			letter, but please keep a copy for your records.
		</div>
	</div>
	<div class="form-row form-group">
		<div class="col-md-12">
			If you require support completing this form, please contact Shine Lawyers on
			<ClassActionPhoneNumber></ClassActionPhoneNumber> or via email to
			<ClassActionEmailAddress></ClassActionEmailAddress>.
		</div>
	</div>

	<div class="form-row form-group">
		<div class="col-md-12">
			If you are having trouble viewing the conflicts disclosure statement or would like to download a copy please
			click <a href={url} title="Ruby Princess Class Action_Conflicts Disclosure Statement" target="_blank"
				>here</a
			>.
		</div>
	</div>

	<div class="top_cont">
		<div class="form_cont">
			<IFrame height="800px" title="Ruby Princess Class Action - Conflicts Disclosure Statement" {url}></IFrame>
		</div>
	</div>

	<form novalidate autocomplete="off">
		<div class="form-row button-row">
			<div class="col-md-12 last">
				<NavigationButtons {persistUrl} {previousPage} {nextPage} nextPageLabel="Submit"></NavigationButtons>
			</div>
		</div>
	</form>
</PageSection>

<style>
	.top_cont {
		margin: 0 auto 20px auto;
	}

	.button-row {
		margin-top: 40px;
	}

	@media (max-width: 768px) {
		.button-row .last {
			text-align: center;
		}
	}
</style>
